<ion-col class="slide-col ion-no-padding">
	<div class="style-block left-part-desktop">
		<div class="header-wrapper">
			<div class="venue_info_block">
				<ion-icon (click)="goBack()" class="back-icon" src="../../../assets/topgolf/blue-back-arrow.svg"></ion-icon>
				<ion-img class="header-logo" src="../../../assets/topgolf/header_logo.svg"></ion-img>
				<div class="right-slot">
					<app-burger-btn></app-burger-btn>
				</div>
			</div>
		</div>

		<div #contentArea class="content-scrollable-area">
			@if (isDeinstag()) {
				<div class="deinstag-header">
					<div class="step">
						<ion-icon name="golf-outline"></ion-icon>
						<span>{{ 'modal_info.gameplay' | translate }}</span>
					</div>
					<div class="step">
						<ion-icon name="fast-food-outline"></ion-icon>
						<span>{{ 'modal_info.food' | translate }}</span>
					</div>
					<div class="step">
						<ion-icon name="beer-outline"></ion-icon>
						<span>{{ 'modal_info.drink' | translate }}</span>
					</div>
				</div>
			} @else if (articleGroup.article?.assets?.large) {
				<ion-row class="image-wrapper">
					<ion-img [src]="articleGroup.article.assets.large" class="main-img full-width"></ion-img>
				</ion-row>
			} @else {
				<ion-img class="no-img full-width" src="../../../assets/topgolf/header_logo.svg"></ion-img>
			}

			<div class="info">
				<ion-row>
					<div class="header-info">
						<div class="product-name">
							<h1 class="title">
								{{ articleGroup.article.name | langObservable | async }}
							</h1>
							@if (findFeatureArray.length > 0) {
								<div class="tags">
									@for (tagsIcon of findFeatureArray; track tagsIcon) {
										<ion-icon [src]="'../../../assets/tags/' + tagsIcon + '.svg'"></ion-icon>
									}
								</div>
							}
						</div>
						<div class="price-row">
							<p class="price">
								{{ articleGroup.article && articleGroup.article.isFromPrice ? ('item_view.price_from' | translate) : '' }}
								{{
									numberToCurrency(
										OrderUtils.totalPrice(articleGroup, order.type, order.preorder.type) / articleGroup.quantity,
										order.currency
									)
								}}
							</p>
						</div>
					</div>
					<ion-col class="ion-no-padding" size="12">
						<p class="desc">
							{{ articleGroup.article.description | langObservable | async }}
						</p>
					</ion-col>
				</ion-row>
			</div>
			@for (optionGroup of articleGroup.article.groups; track optionGroup; let optionGroupIndex = $index) {
				@if (validationUtils.isGroupDependencyFulfilled(articleGroup.article, articleGroup.groups, optionGroup); as dependency) {
					@if (
						dependency?.times >= 0 &&
						optionGroup?.visible &&
						!(optionGroup?.articles?.length === 1 && optionGroup?.limit === 1 && optionGroup?.requiredAmount === 1)
					) {
						@for (dependencyNumber of generateDependencies(dependency); track dependencyNumber) {
							@if (checkIfArticleIsVisible(optionGroup)) {
								<div
									[class.error-item]="errorOptionItemId === optionGroup._id"
									[id]="optionGroup?._id"
									class="show-option-groups"
								>
									<div class="opt-desc-row">
										<h1 class="option-group-description">
											<span class="option-text">{{ optionGroup.description | langObservable | async }}</span>

											<span class="option-limit-badge">
												@if (optionGroup.requiredAmount > 0) {
													(MIN {{ optionGroup.requiredAmount }})
												}
												@if (optionGroup.requiredAmount > 0 && optionGroup.limit > 0) {
													/
												}

												@if (optionGroup.limit > 0) {
													(MAX {{ optionGroup.limit }})
												}
											</span>
										</h1>
									</div>
								</div>
								<ion-col class="option-group-col">
									@if (optionGroup.displayMode !== dm.CHECKBOX) {
										<app-article-option-group-custom
											(openInfo)="showNutrition($event)"
											(selection)="add(0, optionGroupIndex, $event, optionGroup, dependency, dependencyNumber)"
											[articleGroup]="articleGroup"
											[article]="articleGroup.article"
											[currency]="order && order.currency"
											[filtersValues]="filtersValues"
											[optionGroup]="optionGroup"
											[preorderType]="order.preorder.type"
											[selected]="filterMatchingOptions(articleGroup.groups, optionGroup, dependency)"
										>
										</app-article-option-group-custom>
									}
									@if (optionGroup.displayMode === dm.CHECKBOX) {
										<app-article-option-group-checkbox
											(openInfo)="openInfo($event)"
											(selection)="add(0, optionGroupIndex, $event, optionGroup, dependency, dependencyNumber)"
											[article]="articleGroup.article"
											[currency]="venue?.currency"
											[filtersValues]="filtersValues"
											[hasMultiple]="optionGroup.hasMultiple"
											[optionGroupValue]="optionGroup"
											[preorderType]="order.preorder.type"
											[selected]="filterMatchingOptions(articleGroup.groups, optionGroup, dependency)"
										>
										</app-article-option-group-checkbox>
									}
								</ion-col>
							}
						}
					}
				}
			}
			<div class="input-notes">
				<ion-label class="stacked">{{ 'order.note.header' | translate }}</ion-label>
				<ion-item lines="none">
					<ion-input
						class="custom"
						[(ngModel)]="articleGroup.note"
						[placeholder]="'order.note.placeholder' | translate"
					></ion-input>
				</ion-item>
			</div>
		</div>

		@if (order) {
			<div class="button-footer-block">
				<div class="quantity-row">
					<div class="quantity-selector-main">
						<ion-icon
							(click)="decrease()"
							[class.disabled]="articleGroup.quantity <= 1"
							class="quantity-btn"
							src="../../../assets/icon/minus.svg"
						></ion-icon>
						<span class="quantity-text">{{ articleGroup.quantity }}</span>
						<ion-icon (click)="increase()" class="quantity-btn" src="../../../assets/icon/plus.svg"></ion-icon>
					</div>
				</div>
				<div (click)="addToOrder(true)" class="button-checkout">
					<p class="checkout-text">
						{{ 'modal_info.order_btn' | translate }}
						{{ numberToCurrency(OrderUtils.totalPrice(articleGroup, order.type, order.preorder.type), order.currency) }}
					</p>
				</div>
			</div>
		}
	</div>
</ion-col>
